module.exports = "https://cdn.thelire.com/ins/resource/more_bonus.6ccf519e64e9d6561b05918f498197a3.png";